import { Component } from 'react';
import {Card, FormControl, FormGroup, FormLabel} from 'react-bootstrap';
import {connect} from 'react-redux';
import {actions, Control, Errors, Form} from 'forms/rrf';
import {Link} from 'react-router-dom';
import ArrowButton from '../../button-arrow';
import PasswordMaskInput from '../../form/elements/password-mask-input';
import ErrorMessages from '../../../admin/login/error-messages';

import './login-form.css';
import {USER_TYPE_REP, USER_TYPE_ADMIN, USER_TYPE_RETAILER} from '../../../../data/userTypes';

const forgottenUrl = {
  [USER_TYPE_RETAILER]: '/reset-password',
  [USER_TYPE_ADMIN]: '/admin/reset-password',
  [USER_TYPE_REP]: '/team/reset-password',
};

class CommonLoginForm extends Component {
  handleSubmit = (payLoad) => {
    const {dispatch, loginAction} = this.props;
    dispatch(actions.submit('deep.login', loginAction(payLoad, dispatch)));
  };

  render() {
    const {type} = this.props;
    return (
      <Form model="deep.login" onSubmit={this.handleSubmit}>
        <Errors className="errors" component={ErrorMessages} model="deep.login"/>
        <Card className="login">
          <Card.Header>
            <h2 className="text-uppercase login-form-header">
              Login
            </h2>
          </Card.Header>
          <Card.Body>
            <FormGroup>
              <FormLabel>
                E-mail or mobile:
              </FormLabel>
              <Control.text
                component={FormControl}
                model=".login"
              />
            </FormGroup>

            <FormGroup>
              <FormLabel>
                Password:
              </FormLabel>
              <Control
                component={PasswordMaskInput}
                model=".password"
              />
            </FormGroup>
            {type === USER_TYPE_REP && (
              <label>
                <input type="checkbox"/>
                {' '}
                Remember me
              </label>
            )}
            <div id="forgottenPasswordLabel">
              Forgotten password?
              <Link to={forgottenUrl[type] || forgottenUrl[USER_TYPE_RETAILER]}>
                {' '} Click here
              </Link>
            </div>
          </Card.Body>
          <Card.Footer>
            <ArrowButton className="btn-block" color="white">
              Login
            </ArrowButton>
          </Card.Footer>
        </Card>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  login: state.deep.login,
});

export default connect(mapStateToProps)(CommonLoginForm);
